import { Component, OnInit } from '@angular/core';

import { UiPlatformMenuItems } from '../../../../ui-platform/src/lib/modules/menu/menu.model';

@Component({
  selector: 'sh-platform-menu',
  templateUrl: './platform-menu.component.html',
  styleUrl: './platform-menu.component.scss',
  standalone: false
})
export class PlatformMenuComponent implements OnInit {
  usage = `
            <ui-platform-menu
              [type]="'text'"
              [icon]="'translate'"
              [textSize]="'smaller'"
              [menuItems]="menuItems"
              label="English (US)"
              [chevron]="true"
            >
            </ui-platform-menu>
    `;

  menuItemsSample = `
      menuItems: UiPlatformMenuItems = [
        {label: 'English', selected: true, callback: this.firstItemSelected},
        {label: 'Slovak', selectable: true, suffix: '(Primary)'},
        {label: 'Czech', selectable: true},
        {label: 'German', selectable: true, suffix: '(Default)'},
        {divider: true},
        {label: 'Add new language'},
        {label: 'Make selected language primary', disabled: true},
        {label: 'Auto-translate selected language', disabled: true},
        {label: 'Delete selected language', disabled: true},
      ];
    `;

  import = `
    import {UiPlatformMenuComponent} from 'ui-platform';
  `;

  menuItems: UiPlatformMenuItems = [
    { labelCode: 'English', selected: true, callback: this.firstItemSelected },
    { labelCode: 'Slovak', selectable: true, suffixCode: 'general.primary' },
    { labelCode: 'Czech', selectable: true },
    { labelCode: 'German', selectable: true },
    { divider: true },
    { labelCode: 'Add new language' },
    { labelCode: 'general.see-more' },
    { labelCode: 'Make selected language primary', disabled: true },
    { labelCode: 'Auto-translate selected language', disabled: true },
    { labelCode: 'Delete selected language', disabled: true }];

  nestedItems: UiPlatformMenuItems = [
    { labelCode: 'English', selected: true, callback: this.firstItemSelected },
    { labelCode: 'Slovak', selectable: true, suffixCode: '(Primary)' },
    { labelCode: 'Czech', selectable: true },
    { labelCode: 'German', selectable: true, suffixCode: '(Default)' },
    {
      labelCode: 'Other',
      submenu: [
        { labelCode: 'Add new language' },
        { labelCode: 'general.see-more' },
        { labelCode: 'Make selected language primary', disabled: true },
        { labelCode: 'Auto-translate selected language', disabled: true },
        { labelCode: 'Delete selected language', disabled: true }]
    }
  ];

  constructor() {}

  ngOnInit(): void {}

  firstItemSelected() {
    console.log('firstItemSelected');
  }
}
